import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { class: "Button--no-style cross-sell-left-arrow disabled:opacity-20" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "7",
    height: "12"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      transform: "translate(0.256335 0.0708618)",
      d: "M5.5255265 1.2728802C5.7916851 1.0067219 5.8164988 0.58452165 5.5877638 0.29034656L5.5119996 0.20548719C5.2347913 -0.070853516 4.7633719 -0.070853516 4.4726095 0.21990901L0.21807191 4.4744463C-0.072690636 4.7652087 -0.072690636 5.2366281 0.21807191 5.5273905L4.4726095 9.7819281C4.7633719 10.072691 5.2347913 10.072691 5.5255537 9.7819281C5.8163161 9.4911652 5.8163161 9.0197468 5.5255537 8.7289839L1.7983787 5.0009184L5.5255265 1.2728802Z"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { class: "Button--no-style cross-sell-right-arrow disabled:opacity-20" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "7",
    height: "12"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      transform: "translate(0.072876 0.0708618)",
      d: "M0.21813819 1.2728802C-0.048020262 1.0067219 -0.072834127 0.58452165 0.15590085 0.29034656L0.23166507 0.20548719C0.50887376 -0.070853516 0.98029298 -0.070853516 1.2710556 0.21990901L5.5255928 4.4744463C5.8163552 4.7652087 5.8163552 5.2366281 5.5255928 5.5273905L1.2710556 9.7819281C0.98029298 10.072691 0.50887376 10.072691 0.21811123 9.7819281C-0.072651297 9.4911652 -0.072651297 9.0197468 0.21811123 8.7289839L3.945286 5.0009184L0.21813819 1.2728802Z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}